import { render } from "./UserEnrolListComponent.vue?vue&type=template&id=25b446e6"
import script from "./UserEnrolListComponent.vue?vue&type=script&lang=js"
export * from "./UserEnrolListComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__